import { Row, Space, Button } from "antd";
import CompanyTreeOrganizationEdit from "./CompanyTreeOrganizationEdit";

import styles from "../styles/CompanyProfile.module.css";
import { useTranslation } from "react-i18next";

const CompanyOrganizationEdit = ({
  lang = "",
  departmentList = [],
  companyInformation = {},
  organizationMaxLevel = 2,
  onCancel = () => { },
  onSave = () => { },
  getModal = () => { },
  getEditModal = () => { },
  handleOpenCreateModal = () => { },
  handleOpenEditModal = () => { },
  onDeleteDepartment = () => { },
}) => {
  const { t } = useTranslation();

  return (
    <Space
      className={styles.container}
      direction="vertical"
      size={24}
    // style={{ overflow: "auto" }}
    >
      <Row justify="end" className={styles.container}>
        <Space size={20}>
          <Button type="default" onClick={onCancel}
            // className={styles.buttom}
            style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "#2CADE7", padding: "8px 16px", color: "white" }}
          >
            {t("common.submit")}
          </Button>
          {/* <Button className={styles.buttom} onClick={onSave}>
            {t("common.submit")}
          </Button> */}
        </Space>
      </Row>
      <div className="card" style={{ overflow: "auto", boxShadow: "none" }}>
        <CompanyTreeOrganizationEdit
          departmentList={departmentList}
          handleOpenCreateModal={handleOpenCreateModal}
          handleOpenEditModal={handleOpenEditModal}
          companyInformation={companyInformation}
          onDeleteDepartment={onDeleteDepartment}
          organizationMaxLevel={organizationMaxLevel}
          lang={lang}
        />
      </div>
      {getModal()}
      {getEditModal()}
    </Space>
  );
};

export default CompanyOrganizationEdit;
